import { AxiosResponse } from 'axios'
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from '../BaseRepository'

export default class PostsRepository extends BaseRepository {
  constructor (protected endpoint: string, axios: NuxtAxiosInstance) {
    super(endpoint, axios)
  }

  public getFilteredPosts (section: string, size: number = 10): Promise<AxiosResponse> {
    const filterParam = section !== 'все статьи' ? { filter: section } : {}

    return this.$axios.get(`${this.endpoint}`,
      {
        params: {
          'page[size]': size,
          ...filterParam
        }
      }
    )
  }
}
